<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Z3Taam/tc-custom/9798337201290.jpg?1737640606391" alt="This image is the cover for the book Paparazzi, A Becky White Thriller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paparazzi, A Becky White Thriller
      </h1>
      <p class="bookDescription body article font2">
        <b>The tables are turned for a celebrity photographer who’s being stalked, in this mind-blowing thriller featuring PI Becky White.</b><br/><br/> After a traumatic incident forces her out of the police force, Becky’s longtime friend Joanna convinces her to start the White Knight Detective Agency. Their first case seems simple—help photographer Penny with a stalker who appears whenever she works with a band led by singer Troy. But the case turns deadly when Troy’s wife is murdered. And then a child goes missing. . .<br/><br/> As more killings follow, Becky, Joanna, and tech expert Will race to uncover the truth. Becky must confront her own demons to rescue the child, but nothing prepares them for the shocking twist when they discover who has been pulling the strings all along . . .<br/><br/><b>Packed with emotional intensity, <i>Paparazzi</i> is a gripping, page-turning thriller perfect for fans of Angela Marsons.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Fenton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39fe45b2